<template>
  <validation-provider
    class="sm:col-span-2"
    tag="div"
    name="confirm"
    mode="passive"
    :rules="rules"
    v-slot="{ errors }"
  >
    <form-checkbox v-model="internalValue" @change="onInput">
      <p class="text-xs select-none text-gray-600">
        By providing your phone number, you agree to receive text messages from
        Jarvis Analytics. Message and data rates may apply and message frequency
        varies. <span class="leading-none text-xs text-red-400">*</span>
      </p>
      <form-alert-msg slot="error" v-if="errors[0]">{{
        errors[0]
      }}</form-alert-msg>
    </form-checkbox>
  </validation-provider>
</template>

<script>
import { FormAlertMsg, FormCheckbox } from "@/components/Form/";
import { ValidationProvider, extend } from "vee-validate";
extend("confirmed", (value) => {
  if (value) return true;
  return "Please indicate that you agree to the phone number terms.";
});

export default {
  components: {
    ValidationProvider,
    FormAlertMsg,
    FormCheckbox,
  },
  props: ["checked"],
  data() {
    return {
      internalValue: false,
    };
  },
  computed: {
    rules() {
      return "confirmed";
    },
  },
  watch: {
    checked: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input:field", val);
    },
  },
};
</script>
